import ResetPasswordRequest from '../entities/ResetPasswordRequest'
import ResetPasswordResponse from '../entities/ResetPasswordResponse'
import { IUserRepository } from '../repositories/IUserRepository'

export interface IResetPassword {
  execute(params: ResetPasswordRequest): Promise<ResetPasswordResponse>
}

export default class ResetPasswordImpl implements IResetPassword {
  constructor(private readonly userRepository: IUserRepository) {}

  public async execute(
    params: ResetPasswordRequest,
  ): Promise<ResetPasswordResponse> {
    const response = await this.userRepository.resetPassword(params)

    return response
  }
}
